<template >
    <div id="t3">
        <div class="juzhon">
            <div class="boxtitle">
                <span class="tit_left"><img src="../assets/fzfg.png" ></span>
                <div class="nav">
                    <a  @click="ZMchagne('A')" :class="[ZM=='A'?'navactive':'']">{{ Masterlist.lists_A.title }}</a>
                    <a  @click="ZMchagne('B')" :class="[ZM=='B'?'navactive':'']">{{ Masterlist.lists_B.title }}</a>
                </div>
                <span class="tit_right"><a :href="curl+Masterlist['lists_'+ZM].id" target="_blank"> 更多资讯>></a></span>
            </div>

            <div class="Vidcontext">
                <ul>
                    <li v-for="(item,i) in lists" :key="i">
                        <a class="img_box" :href="aurl+item.fileID" target="_blank" ><img :src="item.pic1" alt=""></a>
                        <h3><a :href="aurl+item.fileID" target="_blank" >{{ item.title }}</a></h3>
                        <div class="item_intro">{{item.source}}<span>丨</span>{{item.publishTime}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {inject,ref,onMounted} from 'vue'
export default {
    name:'T3',
    setup(){
        let ztreq=inject('ztreq')
        let aurl=ztreq.data.aurl
        let curl=ztreq.data.curl
        let Masterlist=ref({
            lists_A:{title:'大美抚州',id:'2750',lists:[{videoUrl:"",pic1:"",title:''}]},
            lists_B:{title:'乐游抚州',id:'2784',lists:[{videoUrl:"",pic1:"",title:''}]},
        })
        let ZM=ref('A')
        let lists=ref([{videoUrl:"",pic1:"",title:'',fileID:''}])
        onMounted(()=>{
                axios.get(ztreq.data.geturl+'2750&pageSize=8&articleType=2').then((res)=>{
                Masterlist.value['lists_'+ZM.value].lists=res.data.list
                lists.value = Masterlist.value['lists_'+ZM.value].lists
            });
        });
        function getData(ID){
            axios.get(ztreq.data.geturl+ID+'&pageSize=8&articleType=2').then((res)=>{
                Masterlist.value['lists_'+ZM.value].lists=res.data.list
                lists.value = Masterlist.value['lists_'+ZM.value].lists
            });
        }
        //切换当前显示内容
        function ZMchagne(i){
            ZM.value=i
            if(Masterlist.value['lists_'+ZM.value].lists[0].videoUrl==''){
                let ID = Masterlist.value['lists_'+ZM.value].id
                getData(ID)
            }else{
                lists.value =Masterlist.value['lists_'+ZM.value].lists
            }
            
        }
        return{
            aurl,lists,curl,Masterlist,ZM,ZMchagne
        }
    }  

}
</script>

<style scoped>
#t3{
    min-width: 1200px;
    width:100%;
    height: 700px;   
    background-color: #fff;
    padding-top: 40px;
}
.boxtitle{
    width: 1200px;
    height: 48px;
    overflow: hidden;
    border-bottom: 4px solid #fc0000;
    margin-bottom: 20px;
}
.boxtitle img{
    width: 157px;
}
.tit_left{
    float: left;
}
.tit_right{
    float: right;
    font-size: 18px;
    color: #333;
    margin-top: 18px;
}
.tit_right a{
    font-size: 18px;
    color: #333;
}
.tit_right a:hover{
    color: #fc0000;
    text-decoration: underline;
}
.nav{
    width: 800px;
    display: inline-block;
    padding-left: 20px;
}
.nav a{
    display: inline-block;
    margin-right: 15px;
    height: 30px;
    padding: 0 20px;
    line-height: 30px;
    color: #000;
    background: #eee;
    margin-top: 9px;
    border-radius: 15px;
}
.nav a:hover{
    color: white;
    background: #fc0000;
    cursor: pointer;
}
.nav .navactive{
    color: white;
    background: #fc0000;
}



.Vidcontext ul{
    clear: both;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.Vidcontext ul li{
    width: 272px;
    float: left;
    margin: 20px 10px;
    height: 240px;
    border: 1px solid #b7b6b6;
    overflow: hidden;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 1px #e2e2e2;
}
.Vidcontext ul li:hover{
    border: 1px solid #fc0000;
}
.Vidcontext img{
    width: 100%;
    height: 150px;
}
.img_box{
    display: block;
    height: 150px;
    width: 272px;
    overflow: hidden;
}
.Vidcontext img {transition: .2s ease;display:block;}
.Vidcontext img:hover {	transform: scale(1.2);}
.Vidcontext h3{
    margin-bottom: 5px;
    margin-top: 10px;
    overflow: hidden;
    line-height: 24px;
    max-height: 48px;
    font-size: 16px;
    font-weight: normal;
    padding: 0px 10px 0px 10px;
}
.Vidcontext h3 a{
    color: #000;
}
.Vidcontext h3 a:hover{
    color: #fc0000;
}
.item_intro{
    font-size: 12px;
    color: #666;
    margin-bottom: 30px;
    padding: 0px 10px 0px 10px;
}


</style>